"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgRouter(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M2 26a2 2 0 012-2h32a2 2 0 012 2v10.276a2 2 0 01-2 2H4a2 2 0 01-2-2V26z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M21 10a1 1 0 10-2 0h2zm-2 0v14h2V10h-2z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M14 6c-1.218 1.172-2 2.974-2 5 0 2.025.782 3.828 2 5M26 6c1.218 1.172 2 2.974 2 5 0 2.025-.782 3.828-2 5M11 2a10.949 10.949 0 00-4 8.5 10.95 10.95 0 004 8.5M30 2c2.436 1.993 4 5.056 4 8.5a10.95 10.95 0 01-4 8.5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M7 29h4M14 29h4", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0)] }), void 0));
}
exports.default = SvgRouter;
//# sourceMappingURL=Router.js.map